<footer class="container-fluid">
  <div class="row bg-primary">
    <div class="col-12">
      <div class="footer-content">
        <div class="footer-branding d-flex">
          <!-- <img
            class="d-none d-md-block"
            src="assets/img/icons/logo-footer-lg.svg"
            alt="NYCHA Logo"
            width="44"
            height="54"
          />
          <img
            class="d-md-none"
            src="assets/img/icons/logo-footer-sm.svg"
            alt="NYCHA Logo"
            width="44"
            height="54"
          /> -->

          <h3 class="d-none d-md-block ms-4">{{ copywrite }}</h3>
        </div>

        <!-- <nav class="d-md-none mobile-nav">
          <ul class="nav">
            <li class="nav-item">
              <a
                [routerLink]="['/']"
                routerLinkActive="active"
                [routerLinkActiveOptions]="{ exact: true }"
                class="nav-link"
              >
                Home
              </a>
            </li>

            <li class="nav-item">
              <a [routerLink]="['/infodefinition']" routerLinkActive="active" class="nav-link">
                Info & Definitions
              </a>
            </li>

            <li class="nav-item">
              <a [routerLink]="['/contact']" routerLinkActive="active" class="nav-link">
                Contact Us
              </a>
            </li>
          </ul>
        </nav> -->

        <!-- <div class="connect-with-us">
          <h3>Connect with us</h3>

          <nav>
            <ul class="nav">
              <li class="nav-item">
                <a class="nav-link" href="https://www.facebook.com/">
                  <img
                    src="assets/img/icons/social-media-fb.svg"
                    alt="link to facebook"
                    width="21"
                    height="20"
                  />
                </a>
              </li>

              <li class="nav-item">
                <a class="nav-link" href="https://www.youtube.com/">
                  <img
                    src="assets/img/icons/social-media-youtube.svg"
                    alt="link to youtube"
                    width="21"
                    height="20"
                  />
                </a>
              </li>

              <li class="nav-item">
                <a class="nav-link" href="https://twitter.com/">
                  <img
                    src="assets/img/icons/social-media-twitter.svg"
                    alt="link to twitter"
                    width="21"
                    height="20"
                  />
                </a>
              </li>
            </ul>
          </nav>
        </div> -->
      </div>
    </div>
  </div>

  <!-- hide on md and wider screens -->
  <div class="row copywrite d-md-none">
    <div class="col-12">
      <h2>{{ copywrite }}</h2>
    </div>
  </div>
</footer>
